"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NewTeamMemberOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29 24h-3v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2z"/><path d="M16 2a7 7 0 00-7 7v1.5a9.7 9.7 0 002.9 6.7c-5.7.6-9.9 3.4-9.9 6.7V28a2 2 0 002 2h14a1 1 0 000-2H4v-4c0-2.4 4.4-5 10.7-5a19.4 19.4 0 016 1 1 1 0 10.6-2l-1.7-.4a9.8 9.8 0 003.4-7V9A7 7 0 0016 2zm5 8.5a7.8 7.8 0 01-1.6 4.5 4.5 4.5 0 01-3.4 2c-2.7 0-5-3.6-5-6.5V9.1A5 5 0 0116 4a5 5 0 015 5z"/>';
var NewTeamMemberOutlineSVG = function NewTeamMemberOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.NewTeamMemberOutlineSVG = NewTeamMemberOutlineSVG;
NewTeamMemberOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(NewTeamMemberOutlineSVG);
exports.default = _default;